module.exports = __webpack_public_path__ + "img/r-240.088ac9f8.jpg";